import logEvent from '../logEvent';

function logEventOutage(code, data) {
  logEvent(`OUTG-${code}`, data);
}

export function logEventOutagePageView() {
  logEventOutage('01');
}
